import { Extras as ExtrasType, Price } from 'shared-types/Common';
import { sum } from 'shared-utils';

export const priceWithExtras = (
  selectedRate: { pricePerStay: Price },
  extras: ExtrasType[] | undefined | null,
  selectedExtras: { isSelected?: boolean; quantity?: number }[]
): Price => {
  const amount =
    extras &&
    extras.reduce((acc, extra, index) => {
      if (selectedExtras[index]?.isSelected) {
        const extraAmount = (extra?.price?.amount || 0) * (selectedExtras[index]?.quantity || 1);
        return acc + extraAmount;
      }
      return acc;
    }, selectedRate?.pricePerStay?.amount);
  return { ...selectedRate?.pricePerStay, amount: amount || 0 };
};

export const mapExtrasToBasket = (entityExtras, formExtras) =>
  formExtras &&
  formExtras.reduce((acc, cur, index) => {
    if (cur?.isSelected) {
      const { isSelected: _, option, quantity, ...formData } = cur;
      const { options, ...entityExtraWithNoOptions } = entityExtras[index];
      return [
        ...acc,
        {
          ...entityExtraWithNoOptions,
          ...formData,
          quantity: quantity || 1,
          ...(option && { options: [options[option.value]] }),
        },
      ];
    }
    return acc;
  }, []);

export const combineRoomExtras = (
  multiRoomSelectedExtras?: Record<string, { isSelected?: boolean; quantity: number }[]>
) => {
  if (!multiRoomSelectedExtras) {
    return [];
  }

  const rooms = Object.keys(multiRoomSelectedExtras);

  const maxExtrasCount = Math.max(...rooms.map((room) => multiRoomSelectedExtras[room].length));

  return Array.from({ length: maxExtrasCount }, (_, extraIndex) => {
    const totalQuantity = sum(
      rooms.map((room) => multiRoomSelectedExtras[room][extraIndex]),
      (extra) => extra?.quantity ?? 0
    );

    return {
      isSelected: totalQuantity > 0,
      quantity: totalQuantity,
    };
  });
};
